export default {
  title: 'Modification du nom d\'utilisateur',
  confirmationLabel: 'Confirmation de votre nom d\'utilisateur',
  usernameConfirmation: 'Les 2 noms d\'utilisateur doivent être identiques',
  informationsLabel: 'Le nom d\'utilisateur est invalide. Nous vous recommandons d\'utiliser une adresse courriel en tant que nom d\'utilisateur.',
};
